"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sliders = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));
var _pittaModules = require("@thingsw/pitta-modules");
var _clsx4 = _interopRequireDefault(require("clsx"));
var _Tooltip = require("./Tooltip");
var _Fonts = require("../constants/Fonts");
var _excluded = ["disabled", "labelLeft", "variant", "markClasses", "className", "labelClasses", "railClasses", "trackClasses", "rootClasses", "thumbClasses", "style", "markStyle", "noTooltip", "setting"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)({
  rail: {
    color: _pittaModules.LightColors.primary["1"]
  },
  track: {
    color: _pittaModules.LightColors.primary["7"]
  },
  thumb: {
    width: 18,
    height: 18,
    color: _pittaModules.LightColors.primary["0"],
    boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.14), 0px 1px 1px \n    rgba(0, 0, 0, 0.12), 0px 0px 3px rgba(0, 0, 0, 0.2)",
    marginTop: "-8px",
    "&:hover, &:active, &:focus": {
      boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.14), 0px 1px 1px \n    rgba(0, 0, 0, 0.12), 0px 0px 3px rgba(0, 0, 0, 0.2)"
    }
  },
  disabled: {
    opacity: 0.35,
    "&$thumb": {
      opacity: 1,
      width: 18,
      height: 18,
      color: _pittaModules.LightColors.primary["0"],
      boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.14), 0px 1px 1px\n        rgba(0, 0, 0, 0.12), 0px 0px 3px rgba(0, 0, 0, 0.2)",
      marginTop: -8,
      marginLeft: -6
    },
    disabled: {}
  },
  Ltrack: {
    height: 10,
    borderRadius: 5
  },
  settingTrack: {
    height: 6,
    borderRadius: 9
  },
  Lrail: {
    height: 10,
    borderRadius: 5,
    color: _pittaModules.LightColors.primary["9"]
  },
  settingRail: {
    height: 6,
    borderRadius: 9,
    color: "".concat(_pittaModules.LightColors.primary["7"], "26")
  },
  Lthumb: {
    width: 26,
    height: 26
  },
  settingTumb: {
    marginTop: -6
  },
  Ldisabled: {
    "&$Lthumb": {
      width: 26,
      height: 26
    }
  },
  mark: {
    width: 0,
    height: 0
  },
  //@ts-ignore
  markLabel: _objectSpread(_objectSpread({
    top: 36
  }, _Fonts.Fonts.Default.Body), {}, {
    '&[data-index="0"]': {
      left: "5px!important"
    },
    '&[data-index="1"]': {
      left: "calc(100% - 12px)!important"
    }
  })
});
function ValueLabelComponent(props) {
  var children = props.children,
    open = props.open,
    value = props.value;
  return /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    open: open,
    enterTouchDelay: 0,
    placement: "top",
    title: value
  }, children);
}
function ValueBlueLabelComponent(props) {
  var children = props.children,
    open = props.open,
    value = props.value;
  return /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    open: open,
    enterTouchDelay: 0,
    placement: "top",
    title: value,
    setting: true
  }, children);
}
// export default function DiscreteSlider() {
var Sliders = function Sliders(props) {
  var classes = useStyles();
  var disabled = props.disabled,
    labelLeft = props.labelLeft,
    variant = props.variant,
    markClasses = props.markClasses,
    className = props.className,
    labelClasses = props.labelClasses,
    railClasses = props.railClasses,
    trackClasses = props.trackClasses,
    rootClasses = props.rootClasses,
    thumbClasses = props.thumbClasses,
    style = props.style,
    markStyle = props.markStyle,
    noTooltip = props.noTooltip,
    setting = props.setting,
    restProps = _objectWithoutProperties(props, _excluded);
  var tooltipLabelMarkup = (0, _react.useMemo)(function () {
    if (noTooltip) {
      return undefined;
    }
    //  10/27 uxui 파란툴팁 없는 것으로 변경(Leehj)
    // else if (setting) {
    //   return ValueBlueLabelComponent;
    // }
    return ValueLabelComponent;
  }, [noTooltip]);
  return /*#__PURE__*/_react.default.createElement(_Slider.default, _extends({
    classes: {
      root: rootClasses,
      marked: markClasses,
      mark: (0, _clsx4.default)(classes.mark, markStyle),
      markLabel: labelLeft ? labelClasses : (0, _clsx4.default)(classes.markLabel, labelClasses),
      track: (0, _clsx4.default)(trackClasses, classes.track, variant === "large" && classes.Ltrack, _defineProperty({}, classes.settingTrack, setting)),
      rail: (0, _clsx4.default)(railClasses, classes.rail, variant === "large" && classes.Lrail, _defineProperty({}, classes.settingRail, setting)),
      thumb: (0, _clsx4.default)(thumbClasses, classes.thumb, variant === "large" && classes.Lthumb, _defineProperty({}, classes.settingTumb, setting)),
      disabled: (0, _clsx4.default)(classes.disabled, variant === "large" && disabled && classes.Ldisabled)
    }
    // noTooltip일 때는 툴팁출력 x, setting일때는 파란색 툴팁으로 출력(Leehj)
    ,
    ValueLabelComponent: tooltipLabelMarkup,
    "aria-labelledby": "discrete-slider",
    disabled: disabled
  }, restProps));
};
exports.Sliders = Sliders;